import {
  CustomerDetailsViewQuery,
  CustomerDetailsViewQueryVariables,
} from "@/gql/graphql";
import { gql, useQuery } from "@apollo/client";

export const customerDetailsQuery = gql`
  fragment CustomerDetails on Customer {
    id
    name
    breadCrumbName
    custIndex
    custNo
    isParent
    custStatus {
      id
      name
    }
    parent {
      id
      preselectedHeadAgreement {
        id
      }
    }
    childCustomers {
      id
    }
    statisticalGrouping {
      id
    }
    invoiceCurrency {
      id
      code
    }
    seller {
      id
      name
    }
    salesRegion {
      id
      code
      name
    }
    isStandardCustomer
    hasRebateAgreements
    writeHistory {
      createdAt {
        isoString
      }
      createdBy {
        id
        name
      }
      modifiedAt {
        isoString
      }
      modifiedBy {
        id
        name
      }
    }
    topAgreementDocuments(numberOfDocuments: $numberOfDocuments) {
      id
      agreementId
      customerNumber
      fileName
      agreementValidFromDate
      agreementValidToDate
      agreementDocumentType
      negotiationYear
      writeHistory {
        createdAt {
          isoString
        }
        createdBy {
          id
          name
        }
      }
    }
    topRebateAgreementDocuments(numberOfDocuments: $numberOfDocuments) {
      id
      rebateAgreementId
      customerNumber
      fileName
      rebateAgreementValidFromDate
      rebateAgreementValidToDate
      negotiationYear
      writeHistory {
        createdAt {
          isoString
        }
        createdBy {
          id
          name
        }
      }
    }
    topHeadAgreements(numberOfAgreements: $numberOfAgreements) {
      statusCode
      headAgreementNumber
      name
      customer {
        id
        preselectedHeadAgreement {
          id
        }
      }
      id
      valid {
        start {
          isoString
        }
        end {
          isoString
        }
      }
    }
  }

  query CustomerDetailsView(
    $customerId: ID!
    $numberOfAgreements: Int!
    $numberOfDocuments: Int!
  ) {
    productPrice {
      customers {
        byId(id: $customerId) {
          ...CustomerDetails
        }
      }
    }
  }
`;

export const useCustomerDetailsView = (
  customerId: string,
  numberOfAgreements: number,
  numberOfDocuments: number
) => {
  const { loading, data } = useQuery<
    CustomerDetailsViewQuery,
    CustomerDetailsViewQueryVariables
  >(customerDetailsQuery, {
    variables: {
      customerId,
      numberOfAgreements,
      numberOfDocuments,
    },
  });

  return { loading, customer: data?.productPrice.customers.byId };
};
